/* eslint-disable */
import React, { useEffect, useState } from 'react'
import { request } from 'd3-request'

import get from 'lodash/get'
import Logo from './MlbLogo'

function NamePlate({ settings }) {
    const { namePlate } = settings

    const photoId = get(settings, `namePlate.photoId`) || ''
    const errorPhotoUrl =
        get(settings, `namePlate.errorPhotoUrl`) ||
        'https://content.mlb.com/images/headshots/current/60x60/generic.png'
    let photoUrl =
        get(settings, `namePlate.photoUrl`) ||
        `https://img.mlbstatic.com/mlb-photos/image/upload/w_120,q_100/v1/people/${photoId}/headshot/silo/current`

    if (photoUrl.indexOf('{1}') > -1) {
        photoUrl = photoUrl.replace('{1}', photoId)
    }

    let image = (
        <image x="5" y="10" height="50" width="50" href={errorPhotoUrl} />
    )
    if (settings.namePlate.forcePlayerImage && photoId) {
        image = <image x="5" y="12" height="50" width="50" href={photoUrl} />
    }
    if (settings.namePlate.supressImage) {
        image = null
    }

    const [imageHolder, setImageHolder] = useState(image)

    useEffect(() => {
        async function fetchImage() {
            request(photoUrl)
                .mimeType('image/png')
                .get((err, image) => {
                    if (image) {
                        setImageHolder(
                            <image
                                x="5"
                                y="12"
                                height="50"
                                width="50"
                                href={photoUrl}
                            />
                        )
                    }
                })
        }
        if (!settings.namePlate.forcePlayerImage) {
            fetchImage()
        }
    }, [])

    const defaultX =  settings.namePlate.supressImage ? 20 : 65

    return (
        <g id="namePlate" transform="translate(0,0)">
            <rect
                fill={namePlate.backgroundColor}
                width={settings.svgWidth}
                height={settings.margin.top}
                stroke="#c2c2c2"
            />
            <rect
                fill={
                    namePlate.background === 'none'
                        ? 'none'
                        : `url('#${namePlate.background}')`
                }
                width={settings.svgWidth}
                height={settings.margin.top}
                stroke="#c2c2c2"
            />
            <text
                x={namePlate.primaryTitleX || defaultX}
                y={namePlate.primaryTitleY || 36}
                className="title"
                fill={namePlate.titleFontColor}
                style={{
                    fontSize: namePlate.primaryTitleFontSize,
                    fontFamily: namePlate.primaryTitleFontFamily,
                }}
            >
                {namePlate.primaryTitleText}
            </text>
            <text
                x={namePlate.secondaryTitleX || defaultX}
                y={namePlate.secondaryTitleY || 58}
                className="sub-title"
                fill={namePlate.secondaryFontColor}
                style={{
                    fontSize: namePlate.secondaryTitleFontSize,
                    fontFamily: namePlate.secondaryTitleFontFamily,
                }}
            >
                {namePlate.secondaryTitleText}
                {namePlate.tertiaryTitleText && namePlate.secondaryTitleText ? (
                    <tspan style={{ fill: namePlate.tertiaryFontColor }}>
                        {' '}
                        • {namePlate.tertiaryTitleText}
                    </tspan>
                ) : null}
            </text>
            {imageHolder}
            {namePlate.teamLogoId !== '-1' ? (
                <Logo settings={settings} teamLogoId={namePlate.teamLogoId} />
            ) : null}
        </g>
    )
}

export default NamePlate
